import { render, staticRenderFns } from "./LoginFormView.vue?vue&type=template&id=0a32ae0a"
import script from "./LoginFormView.vue?vue&type=script&lang=js"
export * from "./LoginFormView.vue?vue&type=script&lang=js"
import style0 from "./LoginFormView.vue?vue&type=style&index=0&id=0a32ae0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports